import { render, staticRenderFns } from "./capacity.vue?vue&type=template&id=8351b59c"
import script from "./capacity.vue?vue&type=script&lang=ts"
export * from "./capacity.vue?vue&type=script&lang=ts"
import style0 from "./capacity.vue?vue&type=style&index=0&id=8351b59c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports